import { createStrings } from '@utils/local';
import * as t from 'io-ts';

export const country = t.union([t.literal('cn'), t.literal('jp')]);

export type Country = t.TypeOf<typeof country>;

export const allCountries = country.types.map((t) => t.value);

export const countryStrings = createStrings({
  ja: {
    cn: '中国',
    jp: '日本',
  },
});
